<div class="page-head-section">
  <p>Archers</p>
</div>


<div class="archers-content">
  <div class="filters" style="margin-bottom:50px">
    <input class="input-search" id="myInput" placeholder="Search Applicant by name, email or MemberId" [(ngModel)]="name"
        (input)="FilterByName($event.target.value)">



    <div class="drop-area">
        <p-dropdown placeholder="Filter by gender" [options]="genderList" [(ngModel)]="genderFilter"
            (onChange)="filterByGender($event)"></p-dropdown>
    </div>
    <div class="drop-area">
        <p-dropdown placeholder="Filter by category" [options]="playingCategory" [(ngModel)]="categoryFilter"
            (onChange)="filterByCategory($event)"></p-dropdown>
    </div>
  
    <button (click)="ClearFilters()" class="clear-filter">Clear Filters</button>
  </div>
  <div class="ui-g archer-head-row">
    <div class="ui-g-3">
      <p class="heading-archer" style="text-align: left">Archer</p>
    </div>
    <div class="ui-g-2">
      <p class="heading-archer" >Member Id</p>
    </div>
    <div class="ui-g-2">
      <p class="heading-archer">PlayingCategory</p>
    </div>
    <div class="ui-g-2">
      <p class="heading-archer">DOB</p>
    </div>
    <div class="ui-g-3">
      <p class="heading-archer">Member Association</p>
    </div>
   
  </div>

  <div *ngFor="let data of ArcherData" class="ui-g archer-content-row">
    <div class="ui-g-3">
      <div class="player-name" style="text-align: left">
        <img
          *ngIf="data?.profileImage !== '' || data?.profileImage !== null"
          class="profile-img"
          [src]="global?.basePathImage + data?.profileImage"
          alt=""
        />

        <img
          *ngIf="data?.profileImage === '' || data?.profileImage === null"
          class="profile-img"
          src="assets/icons/player.png"
          alt=""
        />

        <p class="content-archer">{{ data?.fullName }}</p>
      </div>
    </div>
    <div class="ui-g-2">
      <p class="content-archer">{{ data?.memberId }}</p>
    </div>
    <div class="ui-g-2">
      <p class="content-archer">{{ data?.playingCategory }}</p>
    </div>
    <div class="ui-g-2">
      <p class="content-archer">{{ data?.dob | date: "mediumDate" }}</p>
    </div>
    <div class="ui-g-3">
      <div class="gender">
        <p class="content-archer">{{ data?.memberAssociation?.name }}</p>
      </div>
    </div>
    <!-- <div class="ui-g-1">
      <img class="col-img" src="assets/icons/india.png" alt="" />
    </div> -->
  </div>
<div style="margin-top: 20px;font-family: 'Bold';">
  <p-paginator  [rows]="10" [totalRecords]="ArcherMainData?.count" (onPageChange)="paginate($event)"></p-paginator>
</div>

</div>
